import { Box, Button, Alert, AlertTitle, SxProps, Theme } from '@mui/material';
import { FallbackProps } from 'react-error-boundary';

const rootStyles: SxProps<Theme> = {
  display: 'grid',
  height: 400,
  justifyContent: 'center',
  alignContent: 'center',
};

export function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <Box sx={rootStyles}>
      <Alert
        severity='error'
        action={
          <Button onClick={resetErrorBoundary} variant='contained' color='secondary'>
            Reset
          </Button>
        }
      >
        <AlertTitle>Something went wrong!</AlertTitle>
        <pre>{error.message}</pre>
      </Alert>
    </Box>
  );
}
